import React from "react";

const PartnersPage = () => {
  const features = [
    {
      title: "Enhanced Efficiency",
      description:
        "Our broker app streamlines your workflow, helping you focus on what matters most—closing deals.",
      image: "/pricenegotiation.png",
    },
    {
      title: "Seamless Connectivity",
      description:
        "Effortlessly connect with Housing.in, India’s leading real estate marketplace.",
      image: "/searchProperties.png",
    },
    {
      title: "User-Friendly Platform",
      description:
        "Our intuitive interface ensures that you can manage your business without any hassle.",
      image: "/shortlist.png",
    },
  ];

  return (
    <div className="p-6 bg-gray-50">
      {/* Header Section */}
      <header className="text-center py-6">
        <h1 className="text-3xl font-bold text-gray-800">
          India’s Most Trusted Platform for Real Estate Brokers
        </h1>
        <p className="text-gray-600 mt-2">
          Housing.in broker app is designed to empower real estate brokers
          with enhanced efficiency and connectivity.
        </p>
        <p className="text-gray-600 mt-2">
          Brokers gain access to a user-friendly platform that allows them to
          effortlessly connect with Housing.in, a leading real estate
          marketplace.
        </p>
      </header>

      {/* Features Section */}
      <section className="my-12">
        <h2 className="text-2xl font-bold text-gray-800 text-center mb-6">
          Why Choose Our Platform?
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className="flex flex-col items-center bg-white shadow-lg rounded-lg p-6 border-l-4 border-blue-500 hover:shadow-xl transition duration-300"
            >
              <img
                src={feature.image}
                alt={feature.title}
                className="w-16 h-16 rounded-full border-2 border-blue-500 mb-4"
              />
              <h3 className="text-lg font-semibold text-gray-800 mb-2">
                {feature.title}
              </h3>
              <p className="text-gray-600 text-center">{feature.description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Call-to-Action Section */}
      <section className="text-center my-12">
        <h2 className="text-2xl font-bold text-gray-800">
          Join The Future Of Real Estate
        </h2>
        <p className="text-gray-600 mt-4">
          Take your business to the next level with the Housing.in Broker
          App.
        </p>
        <div className="mt-6">
          <a
            href="#"
            className="bg-blue-600 text-white px-6 py-3 rounded-full text-lg shadow-md hover:bg-blue-700 transition duration-300"
          >
            Download Our App
          </a>
        </div>
        {/* <div className="mt-6">
          <img
            src="/partner.png"
            alt="Download App"
            className="mx-auto w-3/4 md:w-1/2 rounded-lg shadow-md"
          />
        </div> */}
      </section>
    </div>
  );
};

export default PartnersPage;
